import React from 'react'
import { MultiSelect, SimpleSelect } from 'react-selectize'

import QuestionStandardTop from './QuestionStandardTop'

import { replaceVariables } from '../../../actions/planning/assignments'

const MultiChoiceQuestion = ({ question, response, onRespond }) => {
  const rawOptions = (question.options || []).map(v => ({
    ...v,
    label: replaceVariables(v.label)
  }))
  const outputField = () => {
    if (rawOptions.length <= 20) {
      const options = rawOptions.sort((a, b) => {
        let ob = a.orderBy - b.orderBy

        if (!ob) {
          if (a.label < b.label) {
            ob = -1
          } else if (a.label > b.label) {
            ob = 1
          } else {
            ob = 0
          }
        }

        //console.log("Comparing", a, "with", b, " = ", ob);
        return ob
      })
      const isChecked = selectedValue => {
        if (question.multipleResponses && Array.isArray(response)) {
          return response.includes(selectedValue)
        }

        return response === selectedValue
      }

      return (
        <div key={`question-${question.id}`} className="row">
          {options.map(o => (
            <div key={`opt=${o.value}`} className="col-sm-6 col-lg-4">
              <div className={question.multipleResponses ? 'checkbox' : 'radio'}>
                <label>
                  <input
                    onChange={evnt => {
                      if (question.multipleResponses) {
                        onRespond(
                          question,
                          o.value,
                          true,
                          evnt.target.checked ? 'addition' : 'deletion'
                        )
                      } else {
                        onRespond(question, o.value, false)
                      }
                    }}
                    type={question.multipleResponses ? 'checkbox' : 'radio'}
                    name={`quest-${question.id}`}
                    checked={isChecked(o.value)}
                    value={o.value}
                  />
                  {replaceVariables(o.label)}
                </label>
              </div>
            </div>
          ))}
        </div>
      )
    }

    if (question.multipleResponses) {
      const answers = response || []
      const values = answers.map(answer => {
        return rawOptions.find(opt => opt.value === answer)
      })

      //  console.log('Rendering multi select with answers=', answers, 'values=', values)

      return (
        <MultiSelect
          style={{ width: '100%' }}
          theme="bootstrap3"
          values={values}
          options={rawOptions.filter(opt => !answers.find(a => a === opt.value))}
          onValuesChange={newVals => {
            onRespond(
              question,
              newVals.map(newVal => newVal.value),
              true
            )
          }}
        />
      )
    }

    const value = rawOptions.find(opt => opt.value === response)
    const options = rawOptions.filter(opt => response !== opt.value)

    return (
      <SimpleSelect
        style={{ width: '100%' }}
        theme="bootstrap3"
        value={value}
        options={options}
        onValueChange={newVal => {
          onRespond(question, newVal && newVal.value, false)
        }}
      />
    )
  }

  return (
    <div>
      <QuestionStandardTop question={question} key="qst" />
      {outputField()}
    </div>
  )
}

export default MultiChoiceQuestion
